import PaFormSteps from "../../../shared/PaFormSteps";
import {apiStatus} from "../../../shared/enums";
import {fetchDrugList} from "../../../shared/api-service";

import {commonMethods} from "./common-methods";

export const createMethods = ([state, setState]) => {

    const cm = commonMethods([state,setState])

    const disableNext = () => {
        setState(prev => {
            const steps = prev.create.steps;
            steps[prev.create.currentStep].hasNext = false;
            return {...prev, create: {...prev.create, steps}}
        })
    }

    const enableNext = () => {
        setState(prev => {
            const steps = prev.create.steps;
            steps[prev.create.currentStep].hasNext = true;
            return {...prev, create: {...prev.create, steps}}
        })
    }

    const goNext = () => {
        setState(prev => {
            const steps = prev.create.steps;
            steps[prev.create.currentStep].completed = true;
            window.scrollTo(0,0);
            return {
                ...prev,
                create: {
                    ...prev.create,
                    currentStep: prev.create.currentStep + 1,
                    steps
                }
            }
        })
    }
    const goBack = () => {
        setState(prev => {
            const steps = prev.create.steps;
            window.scrollTo(0,0);
            return {
                ...prev,
                create: {
                    ...prev.create,
                    currentStep: prev.create.currentStep - 1,
                    steps
                }
            }
        })
    }

    const nextStep = async () => {
        const onNext = PaFormSteps[state.create.currentStep].onNext;
        let next = true;
        let hasError = false;
        let priorAuthNumber;
        if (onNext) {
            cm.setStatus(apiStatus.LOADING)
            try {
                const { retry, success, message, authNumber} = await onNext(state.fields, cm.setFields, cm.setOperation)
                priorAuthNumber = authNumber
                if (success) {
                    next = true;
                    cm.setStatus(apiStatus.SUCCESS)
                    cm.setBanner({message, severity: 'success'})
                } else {
                    next = retry ? true : false;
                    hasError = true
                    cm.setStatus(apiStatus.ERROR)
                    cm.setBanner( {message, severity: 'error'})
                }
            } catch (error) {
                hasError = true
                cm.setStatus(apiStatus.ERROR)
                cm.setBanner( { message: 'System encounter an error. Please try again later.' })
            }
        }

        if (next) {
            if (!hasError) {
                if (state.create.currentStep < PaFormSteps.length - 1) {
                    goNext();
                } else {
                    cm.setOperation('success', priorAuthNumber)
                }
            }
        }
    }

    const prevStep = () => {
        const onBack = PaFormSteps[state.create.currentStep].onBack;
        const canGoBack = !onBack || (onBack && onBack( state.fields, cm.setFields));
        if (canGoBack) {
            goBack()
        }
    }

    const getRecords = () => {

        setState(prev => (
            {
                ...prev,
                create: {
                    ...prev.create,
                    status: apiStatus.LOADING,
                    data: null,
                    error: null,
                }
            }
        ))
                    
        fetchDrugList()
            .then(data => {
                setState(prev => {
                    const newState = {
                    ...prev,
                        create: {
                        ...prev.create,
                                status: apiStatus.SUCCESS,
                                data,
                                error: null,
                        }
                    }
                    return (newState)
                })
            })
            .catch(error => {
                setState(prev => {
                    const newState = {
                        ...prev,
                        bannerProps: {
                            message: error.message,
                            severity: 'error',
                            open: true
                        },
                        create: {
                            ...prev.create,
                            status: apiStatus.ERROR,
                            data: null,
                            error
                        }
                    }
                    return (newState)
                })
            })
    }

    // Check if we are on last step - SUMMARY - and mark it as completed
    // If we are not on it, mark it as incomplete
    const setFinalStepStatus = () => {
        const lastStep = PaFormSteps.length - 1
        const status = state.create.currentStep === lastStep;
        setState(prev => {
            const steps = prev.create.steps
            steps[lastStep].completed = status
            steps[lastStep].active = status
            return {
                ...prev,
                create: {
                    ...prev.create,
                    steps
                }
            }
        })
    };

    const validateAllSteps = () => {
        setState(prev => {
            const steps = PaFormSteps.map((step, i) => {
                const isValid = i < PaFormSteps.length - 1 ? validateStep(i) : true
                const completed = isValid ? prev.create.steps[i] && prev.create.steps[i].completed : false;
                return {
                    ...prev.create.steps[i],
                    completed,
                    isValid,
                }
            });

            return {
                ...prev,
                create: {
                    ...prev.create,
                    steps
                }
            }
        })
    }

    const validateStep = (stepNumber = state.create.currentStep) => {
        const step = PaFormSteps[stepNumber];
        let hasErrors = false;
        if (step) {
            step.fields.forEach(fieldsRow => {
                fieldsRow.forEach(field => {
                    if (!hasErrors && state.fields[field]) {
                        const {isDirty, value} = state.fields[field];
                        const params = {isDirty, value, field, state};
                        const errors = cm.getErrors(params);
                        if (errors.length > 0) {
                            hasErrors = true;
                        }
                    }
                })
            });
        }
        return !hasErrors;
    }

    return {
        disableNext,
        enableNext,
        goNext,
        getRecords,
        nextStep,
        prevStep,
        setFinalStepStatus,
        validateAllSteps,
        validateStep
    }
}